import '@mdi/font/css/materialdesignicons.css';
import VueIcons from '@icabbi/vue-icons';
import Vue from 'vue';

import Vuetify, {
  VAlert,
  VApp,
  VAppBar,
  VAppBarNavIcon,
  VAutocomplete,
  VAvatar,
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VCheckbox,
  VChip,
  VContainer,
  VContent,
  VDataTable,
  VDatePicker,
  VCol,
  VRow,
  VDialog,
  VDivider,
  VFlex,
  VFooter,
  VForm,
  VIcon,
  VImg,
  VInput,
  VLayout,
  VList,
  VListItem,
  VListItemAction,
  VListItemIcon,
  VListItemTitle,
  VListItemContent,
  VListItemSubtitle,
  VMenu,
  VMessages,
  VNavigationDrawer,
  VProgressCircular,
  VPagination,
  VSelect,
  VSnackbar,
  VSpacer,
  VTextarea,
  VTextField,
} from 'vuetify/lib';


Vue.use(Vuetify, {
  components: {
    VAlert,
    VApp,
    VAppBar,
    VAppBarNavIcon,
    VAutocomplete,
    VAvatar,
    VBtn,
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VCheckbox,
    VChip,
    VContainer,
    VContent,
    VCol,
    VRow,
    VDataTable,
    VDatePicker,
    VDialog,
    VDivider,
    VFlex,
    VFooter,
    VForm,
    VIcon,
    VImg,
    VInput,
    VLayout,
    VList,
    VListItem,
    VListItemAction,
    VListItemIcon,
    VListItemTitle,
    VListItemContent,
    VListItemSubtitle,
    VMenu,
    VMessages,
    VNavigationDrawer,
    VProgressCircular,
    VPagination,
    VSelect,
    VSnackbar,
    VSpacer,
    VTextarea,
    VTextField,
  },
});

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    values: VueIcons.allIcons(),
  },
});
